import { mapState } from 'vuex'

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    carInsuranceVehicleForm: () =>
      import('~/components/layouts/car-insurance-vehicle-form/index'),
    carInsurancePersonalForm: () =>
      import('~/components/layouts/car-insurance-personal-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      vehicleData: {},
      personalData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      return {
        insured_name: this.personalData.firstName,
        insured_lastname: this.personalData.lastName,
        insured_email: this.personalData.email,
        insured_dob: this.personalData.insuredDob,
        insured_phone: String(this.personalData.phone),
        license_issue_date: this.personalData.licenseIssue,
        insured_postcode: this.personalData.postalCode,
        number_years_insured: this.personalData.yearsInsured,
        no_claims_years: this.personalData.yearsNoAccidents,
        claims_last_five_years: this.personalData.numberAccidents,
        tax_number: this.personalData.nif,
        car_registration_date: this.vehicleData.carRegistrationDate,
        tyla_code: this.vehicleData.version,
        license_plate: this.vehicleData.licensePlate,
        user_language: 'PT' // this.userLanguage,
      }
    },
    simulationDataExtraInfo() {
      return {
        insured_name: this.personalData.firstName,
        insured_lastname: this.personalData.lastName,
        insured_email: this.personalData.email,
        insured_dob: this.personalData.insuredDob,
        insured_phone: parseInt(this.personalData.phone, 10),
        license_issue_date: this.personalData.licenseIssue,
        insured_postcode: this.personalData.postalCode,
        number_years_insured: this.personalData.yearsInsured,
        no_claims_years: this.personalData.yearsNoAccidents,
        claims_last_five_years: this.personalData.numberAccidents,
        tax_number: this.personalData.nif,
        car_registration_date: this.vehicleData.carRegistrationDate,
        tyla_code: this.vehicleData.version,
        license_plate: this.vehicleData.licensePlate,
        user_language: 'PT', // this.userLanguage,
        versionLabel: this.vehicleData.versionLabel,
        manufacturerLabel: this.vehicleData.manufacturerLabel
      }
    }
  },
  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },
    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0 ? 'car_simulation_start' : 'car_step1_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },
    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'car_simulation'
          })
          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },
    sendToServer() {
      return this.$axios.post(
        '/carinsurance/createquote',
        this.simulationData,
        {
          headers: {
            'Content-type': 'application/json; charset=utf-8'
          },
          withCredentials: true
        }
      )
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.id, response.hash)
      this.saveSimulationData(this.simulationDataExtraInfo)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-automovel-resultados-id-hash',
          params: {
            id: response.id,
            hash: response.hash
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id, hash) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit('localStorage/ADD_ANONYMOUS_CAR_SIMULATION', {
        id,
        hash
      })
    }
  }
}
